export default "__VITE_ASSET__UxXNHJqo__"